import { IS_TEST_DEPLOYMENT } from '../config'

/**
 * The TEST / BETA strip. Owner decision 2026-09-30: the new payment system is
 * tested IN PARALLEL with the live legacy one (beta.feesubscription.com), so
 * nobody may mistake the test back-office for the live system. Shown on every
 * page (signed in or not) unless the runtime config says `production` on a
 * non-beta host — `isTestDeployment` in src/config.ts decides; `show` exists
 * for tests only.
 */
export function TestDeploymentBanner({ show = IS_TEST_DEPLOYMENT }: { show?: boolean }) {
  if (!show) return null
  return (
    <div className="fs-test-banner" role="note" aria-label="Test system">
      <strong>TEST / BETA</strong> — this is not the live payment system. Use Stripe test cards only; nothing
      here is real money or real customer data.
    </div>
  )
}
